import { QuestionMatching, QuestionType } from "./question";
export class QuestionMatcher {
    constructor(questions) {
        this.questions = questions.slice();
    }
    subset(propertiesListA, propertiesListB) {
        for (var i = 0; i < propertiesListA.length; i++) {
            if (propertiesListB.indexOf(propertiesListA[i]) < 0) {
                return false;
            }
        }
        return true;
    }
    isMatch(client, community) {
        for (var i = 0; i < this.questions.length; i++) {
            var q = this.questions[i];
            var type = q.questionType;
            var matching = q.matchingCriteria;
            var clientProperties = client.properties[q.id ?? ""];
            var communityProperties = community.properties[q.id ?? ""];
            if (type == QuestionType.binary) {
                if (communityProperties && !communityProperties) {
                    return false;
                }
            }
            if (type == QuestionType.nary) {
                if (matching == QuestionMatching.equal) {
                    if (!this.subset(clientProperties, communityProperties) ||
                        !this.subset(communityProperties, clientProperties)) {
                        return false;
                    }
                }
                if (matching == QuestionMatching.clientsubset &&
                    !this.subset(clientProperties, communityProperties)) {
                    return false;
                }
                if (matching == QuestionMatching.communitysubset &&
                    !this.subset(communityProperties, clientProperties)) {
                    return false;
                }
            }
        }
        return true;
    }
}
//# sourceMappingURL=matcher.js.map